export default __webpack_public_path__ + "static/media/watch-4.6466e3b7.png";